/**
 * 写cookies
 * @param {string} name 字段KEY
 * @param {string} value 字段VALUE
 * @param {number} time 失效时间
 */
const setCookie = (name, value, time) => {
    var Days = time || 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString();
};

/**
 * 读取cookies
 * @param {string} cname 字段KEY
 */
const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

/**
 * 删除cookies
 * @param {string} name 字段KEY
 */
const delCookie = (name) => {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
};
/**
 * 时间戳转换成时间
 * @param {number} times 时间戳
 */
const timetrans = (times) => {
    let date = new Date(times + 8 * 3600 * 1000); // 增加8小时
    return date.toJSON().substr(0, 16).replace('T', ' ');
}

/**
 * 校验手机号
 * @param {number | string} cellphone 手机号码
 */
const checkCellphone = (cellphone) => {
    const reg = /^1[0-9]{10}$/;
    const flag = reg.test(cellphone);
    return flag;
}

const getAge = (identify) => {
    var UUserCard = identify;
    if (UUserCard != null && UUserCard != '') {
        //获取年龄
        var myDate = new Date();
        var month = myDate.getMonth() + 1;
        var day = myDate.getDate();
        var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
        if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
            age++;
        }
        return age;
        //				
    }
}

/**
 * 校验验证码
 * @param {number | string} verifycode 验证码
 */
const checkVerifycode = (verifycode) => {
    const reg = /^[0-9]{6}$/;
    const flag = reg.test(verifycode);
    return flag;
}

/**
 * 校验传真
 * @param {number | string} fax 传真
 */
const checkFax = (fax) => {
    const reg = /^(?:\d{3,4}-)?\d{7,8}(?:-\d{1,6})?$/;
    const flag = reg.test(fax);
    return flag;
}

/**
 * 校验邮编
 * @param {number | string} postalcode 邮编
 */
const checkPostalcode = (postalcode) => {
    const reg = /^[1-9]\d{5}$/;
    const flag = reg.test(postalcode);
    return flag;
}

/**
 * 检验身份证
 * @param {number | string} idCard 身份证号码
 */
const isIdCardNo = (idCard) => {
    //15位和18位身份证号码的正则表达式
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); // 将前17位加权因子保存在数组里
            var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
            var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
            for (var i = 0; i < 17; i++) {
                idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }
            var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
            var idCardLast = idCard.substring(17); // 得到最后一位身份证号码
            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                if (idCardLast == "X" || idCardLast == "x") {
                    return true;
                } else {
                    return false;
                }
            } else {
                //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                if (idCardLast == idCardY[idCardMod]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    } else {
        return false;
    }
}

/**
 * 获取身份证生日
 * @param {number | string} value 身份证号码
 */
function getBirthById(value) {
    if (!value) {
        return "";
    }
    var year = "1900";
    var month = "1";
    var day = "1";
    if (value.length == 15) {
        year = "19" + value.substr(6, 2);
        month = value.substr(8, 2);
        day = value.substr(10, 2);
    } else if (value.length == 18) {
        year = value.substr(6, 4);
        month = value.substr(10, 2);
        day = value.substr(12, 2);
    } else {
        return "";
    }
    return year + "-" + month + "-" + day;
}

/**
 * 获取身份证性别
 * @param {number | string} value 身份证号码
 */
function getSexById(value) {
    if (!value) {
        return "未知";
    } else if (value.length == 15) {
        return parseInt(value.substr(14, 1)) % 2 ? "男" : "女";
    } else if (value.length == 18) {
        return parseInt(value.substr(16, 1)) % 2 ? "男" : "女";
    } else {
        return "未知";
    }
}

/**
 * 检验军官证
 * @param {number | string} idCard 军官证号码
 */
function isJuncode(idCard) {
    var regIdCard = /^[a-zA-Z0-9]{7,21}$/;
    //如果通过该验证，说明军官证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        return true;
    } else {
        return false;
    }
}

/**
 * 校验银行卡号
 * @param {number | string} bankCard 银行卡号
 */
const bankCardLength = (bankCard) => {
    // 目前一般最短16位，最长19位。深层次的校验无法进行
    const bankId = '' + bankCard;
    if (bankId.length < 16 || bankId.length > 19) {
        return false;
    } else {
        return true;
    }
}

/**
 * 校验邮箱
 * @param {string} mail 邮箱
 */
const checkMail = (mail) => {
    const reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    const flag = reg.test(mail);
    return flag;
}

function formatNumber (n) {
	n = n.toString()
	return n[1] ? n : '0' + n
}

//得到时间格式2018-10-02
const formatDate = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	return [year,month, day].map(formatNumber).join('-')
}

/**
* 获取数天前或数天后的日期
* num是正数表示之后的时间，num负数表示之前的时间，0表示今天
*/
function fun_date(num) { 
	var date1 = new Date();
	//今天时间
	var time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate()
	var date2 = new Date(date1);
	 date2.setDate(date1.getDate() + num);
	 var time2 = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate(); 
	return time2;
}

/**
* 计算两个日期之间的天数
* strDateStart为开始日期，strDateEnd为结束日期，格式为2018-10-05
*/
function getDays(strDateStart, strDateEnd) {
	var strSeparator = "-"; //日期分隔符
	var oDate1;
	var oDate2;
	var iDays;
	oDate1 = strDateStart.split(strSeparator);
	oDate2 = strDateEnd.split(strSeparator);
	var strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
	var strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
	iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
return strDateS>strDateE ? -iDays : iDays;
}

function isPCWechat() {
    const isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    const isWindowsWechat = window.navigator.userAgent.match(/WindowsWechat/i)
    const isMacWechat = window.navigator.userAgent.match(/MacWechat/i)
    console.log('window.navigator.userAgent.match', window.navigator.userAgent)
    console.log('isMobile', isMobile)
    console.log('isWindowsWechat', isWindowsWechat)
    console.log('isMacWechat', isMacWechat)
    isMobile && console.log('isMobile[0]', isMobile[0])
    return (isWindowsWechat || isMacWechat) && !isMobile
}

module.exports = {
    setCookie,
    getCookie,
    delCookie,
    timetrans,
    checkCellphone,
    getAge,
    checkVerifycode,
    checkFax,
    checkPostalcode,
    isIdCardNo,
    bankCardLength,
    checkMail,
    getBirthById,
    getSexById,
    isJuncode,
    formatDate,
    fun_date,
    getDays,
    isPCWechat
}